import { Grid } from '@mui/material';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Select } from 'antd';
import { validateInput } from 'pages/globals/global';
import CustomTextInput from 'components/inputs/CustomTextInput';
import FormSubmitButton from 'components/button/FormSubmitButton';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import ComptrollerModalContainer from 'components/modal/ComptrollerModalContainer';
import { useCreateReportMutation } from 'store/features/comptroller/comptrollerApi';

const ReportCreateModal = ({ setOpenCreateModal, setReloadTable }) => {
	const [form] = Form.useForm();

	const [screenSize, setScreenSize] = useState('md');
	const [submitData, setSubmitData] = useState(null);
	const [submitForm, setSubmitForm] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);

	const [moduleList, setModuleList] = useState([]);
	const [subModuleList, setSubModuleList] = useState([]);
	//const [processCodeList, setProcessCodeList] = useState([]);

	const { profileData = {} } = useSelector((state) => state?.profile);

	const [createReport, { data: reportCreated }] = useCreateReportMutation();
	const [getSelectOptionsList, { data: selectOptionsList, isSuccess: isSelectOptionsListSuccess }] = useSendControlDataMutation();

	const callGetOptionsList = ({ modules = [], subModules = [] }) => {
		const payload = {
			modules,
			subModules,
			processCodes: [],
		};

		const jsonString = JSON.stringify(payload);

		const base64Data = btoa(jsonString);

		const formattedPayload = {
			payload: payload,
			data: base64Data,
			processCode: 'reports',
			scriptName: 'modules-submodules-processCodes',
		};

		getSelectOptionsList(formattedPayload);
	};

	const handleFormChange = ({ value, name }) => {
		if (name === 'module' || name === 'subModule') {
			form.setFieldsValue({ processCode: null });

			if (name === 'module') {
				form.setFieldsValue({ subModuleCode: null });
			}

			if (name === 'module') {
				callGetOptionsList({ modules: [value], subModules: [] });
			} else if (name === 'subModule') {
				callGetOptionsList({ modules: [form.getFieldValue('moduleCode')], subModules: [value] });
			}
		}
	};

	useEffect(() => {
		callGetOptionsList({ modules: [], subModules: [] });
	}, []);

	useEffect(() => {
		if (isSelectOptionsListSuccess) {
			setModuleList(selectOptionsList?.responseData?.moduleList ?? []);
			setSubModuleList(selectOptionsList?.responseData?.subModuleList ?? []);
			//setProcessCodeList(selectOptionsList?.responseData?.processCodeList ?? []);
		}
	}, [isSelectOptionsListSuccess]);

	const handleClose = () => {
		setOpenCreateModal(false);
	};

	const submitHandle = (data) => {
		createReport({
			activationStatus: '',
			name: data.name ?? '',
			moduleCode: data.moduleCode,
			moduleName: data.moduleName,
			// processCode: data?.processCode,
			// processName: data?.processName,
			createdBy: profileData?.userId,
			modifiedBy: profileData?.userId,
			description: data?.description ?? '',
			staticFormUrl: data?.staticFormUrl ?? '',
			// processVersion: data?.processVersion,
			subModuleCode: data.subModuleCode ?? '',
			subModuleName: data.subModuleName ?? '',
			visibleInModule: data.visibleInModule ?? false,
			visibleInGlobal: data.visibleInGlobal ?? false,
			visibleIn: data.visibleIn ?? [],
			companyCode: profileData?.creatorOrganizationId,
		});
	};

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setConfirmModal(true);
	};

	useEffect(() => {
		if (reportCreated?.status === 'SUCCESS') {
			toast.success('Success! Action completed.', toastConfig);

			setReloadTable((prev) => !prev);
			setOpenCreateModal(false);
		} else if (reportCreated?.status === 'FAILED') {
			toast.error(reportCreated?.message, toastConfig);

			setSubmitForm(false);
			setSubmitData(null);
		}
	}, [reportCreated]);

	useEffect(() => {
		if (submitForm && submitData) {
			setReloadTable((prev) => !prev);

			submitHandle(submitData);
		}
	}, [submitForm]);

	return (
		<ComptrollerModalContainer
			form={form}
			viewType={false}
			showModal={true}
			title="Create Report"
			screenSize={screenSize}
			handleClose={handleClose}
			onFieldsChange={() => {}}
			confirmModal={confirmModal}
			setScreenSize={setScreenSize}
			handleSubmit={handleModalSubmit}
			setConfirmModal={setConfirmModal}
			handleDeactivate={() => setSubmitForm(true)}
			modalData={{
				head: 'Report',
				label: 'Do you want to create',
			}}
		>
			<Grid container rowSpacing={4.5} columnSpacing={2.75}>
				<Grid item xs={24} lg={24}>
					<Row gutter={[16, 0]} style={{ marginTop: '12px', marginBottom: '20px' }}>
						<Form.Item noStyle name="id" />
						<Form.Item noStyle name="reportCode" />
						<Form.Item noStyle name="moduleName" />
						{/* <Form.Item noStyle name="processName" /> */}
						<Form.Item noStyle name="subModuleName" />
						{/* <Form.Item noStyle name="processVersion" /> */}
						<Form.Item noStyle name="activationStatus" />
						<Form.Item noStyle name="visibleInModule" />
						<Form.Item noStyle name="visibleInGlobal" />

						<Col xs={24}>
							<Form.Item name="moduleCode" label="Module">
								<Select
									allowClear
									placeholder="Select user"
									style={{ width: '100%' }}
									onChange={(value, option) => {
										form.setFieldsValue({
											moduleName: option?.children || '',
										});

										handleFormChange({ value, name: 'module' });
									}}
									rules={[
										{
											required: true,
											message: 'Module is required',
										},
									]}
								>
									{moduleList?.map((module) => (
										<Select.Option value={module?.moduleCode} key={module?.moduleName}>
											{module?.moduleName}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={24}>
							<Form.Item name="subModuleCode" label="Sub Module">
								<Select
									allowClear
									placeholder="Select user"
									style={{ width: '100%' }}
									onChange={(value, option) => {
										form.setFieldsValue({
											subModuleName: option?.children || '',
										});

										handleFormChange({ value, name: 'subModule' });
									}}
									rules={[
										{
											required: true,
											message: 'Sub module is required',
										},
									]}
								>
									{subModuleList?.map((subModule) => (
										<Select.Option value={subModule?.subModuleCode} key={subModule?.subModuleName}>
											{subModule?.subModuleName}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={24}>
							<Form.Item name="visibleIn" label="Visible In">
								<Select
									allowClear
									mode="multiple"
									placeholder="Select user"
									style={{ width: '100%' }}
									onChange={(value) => {
										form.setFieldsValue({
											visibleInGlobal: value?.includes('visibleInGlobal'),
											visibleInModule: value?.includes('visibleInModule'),
										});
									}}
									rules={[
										{
											required: true,
											message: 'Process code is required',
										},
									]}
								>
									{[
										{ name: 'Global', value: 'visibleInGlobal' },
										{ name: 'Module', value: 'visibleInModule' },
									]?.map((processCode) => (
										<Select.Option value={processCode?.value} key={processCode?.value}>
											{processCode?.name}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={24}>
							<CustomTextInput
								form={form}
								name="name"
								label="Report Name"
								placeholder="Enter report name"
								rules={[
									{
										validator: validateInput,
									},
								]}
							/>
						</Col>

						<Col xs={24}>
							<CustomTextInput
								form={form}
								name="description"
								label="Short Description"
								placeholder="Enter short description"
								rules={[
									{
										validator: validateInput,
									},
								]}
							/>
						</Col>

						<Col xs={24}>
							<CustomTextInput
								form={form}
								name="staticFormUrl"
								label="Static Form URL"
								placeholder="Enter static form URL"
								rules={[
									{
										validator: validateInput,
									},
								]}
							/>
						</Col>

						<Col xs={24} sm={24} md={24} xl={24}>
							<FormSubmitButton activate={false} />
						</Col>
					</Row>
				</Grid>
			</Grid>
		</ComptrollerModalContainer>
	);
};

export default ReportCreateModal;
